/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import axios from "axios";
import { getToken, getTokenForFormData } from "../../../auth";
interface DishLimit {
  currentCount: number;
  maxAllowed: number;
}
//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;

const listDishes = async (ChefId: any, filterData: any) => {
  const response = await axios.post(
    `${API_URL}list-dish/${ChefId}`,
    filterData
  );
  return response.data;
};
const DishPlan = async (chefId: any) => {
  const response = await axios.get(`${API_URL}dish-plan/${chefId}`);
  return response.data;
};
export const getDishLimit = async (chefId: string) => {
  const { data } = await axios.get(`${API_URL}dish-limit/${chefId}`);
  return data; // { status: true, data: { currentCount: number, maxAllowed: number } }
};

const DishCreate = async (data: FormData) => {
  const response = await axios.post(`${API_URL}add-dish`, data);
  return response.data;
};

const DishUpdate = async (id: any, data: FormData) => {
    const response = await axios.put(
    `${API_URL}update-dish/${id}`,
    data
  );
  
  return response.data;
};

const updateDish = async (id: any, enableDisableStatus: any) => {
        const response = await axios.put(
    `${API_URL}enable-disable-dish/${id}`,
    enableDisableStatus
  );
  return response.data;
};

const deleteDish = async (id: any) => {
  const response = await axios.put(`${API_URL}delete-dish/${id}`);
  return response.data;
};

const getDishView = async (id: any) => {
  const response = await axios.get(`${API_URL}view-dish/${id}`);
  return response.data;
};

// const getDefaultImages = async () => {
//   const response = await axios.get(`${API_URL}get-default-dish-images`);
//   return response?.data;
// };

const createCategory = async (data: FormData) => {
  const response = await axios.post(`${API_URL}add-category`, data);
  return response.data;
};

const checkDuplicateDish = async (id: any, name: any) => {
  const response = await axios.post(
    `${API_URL}find-duplicate-dish/${id}`,
    { name },
    getToken()
  );
  return response.data;
};
const checkDuplicateCategory = async (name: any) => {
  const response = await axios.post(
    `${API_URL}find-duplicate-category`,
    { name },
    getToken()
  );
  return response.data;
};

const getIngredient = async (chefId: any, search?: any) => {
  const res = await axios.post(`${API_URL}get-ingredient`, {
    chefId, search
  });
  return res;
};

const getCategory = async (chefId: any, search?: any) => {
  const res = await axios.post(`${API_URL}list-category-approve`, {
    chefId, search
  });
  return res;
};
const getCuisine = async () => {
  const res = await axios.get(`${API_URL}get-cuisine`);
  return res;
};

const getType = async () => {
  const res = await axios.get(`${API_URL}get-type`, getToken());
  return res;
};
const getMeasurement = async () => {
  const res = await axios.get(
    `${API_URL}get-measurement`,
    getToken()
  );
  return res;
};
const addingredients = async (data: any) => {
    const response = await axios.post(`${API_URL}add-ingredient`, data);
  return response.data;
};

const findDuplicateIngredient = async (name: any) => {
    const response = await axios.post(
    `${API_URL}find-duplicate-ingredient`,
    { name },
    getToken()
  );
  return response.data;
};
const getAddonsType = async (chefId: any) => {
  const res = await axios.post(`${API_URL}get-addons-type`, {
    chefId,
  });
  return res;
};

const getDishAddons = async (chefId: any) => {
  const res = await axios.post(`${API_URL}get-addons`, {
    chefId,
  });
  return res;
};

const getDropdownForBulk = async (data: any) => {
  const response = await axios.post(`${API_URL}dropdown-list-forbulk`, data);
  return response.data;
};

const BulkDishCreate = async (data: FormData) => {
  const response = await axios.post(`${API_URL}bulk-add-dish-bydatafile`, data, getTokenForFormData());
  return response.data;
};

export {
  listDishes,
  getCategory,
  getCuisine,
  getType,
  DishCreate,
  updateDish,
  deleteDish,
  getDishView,
  createCategory,
  checkDuplicateCategory,
  checkDuplicateDish,
  DishUpdate,
  getIngredient,
  addingredients,
  findDuplicateIngredient,
  getMeasurement,
  getDishAddons,
  getAddonsType,
  DishPlan,
  // getDefaultImages
  getDropdownForBulk,
  BulkDishCreate,
};